import { createClient } from '@supabase/supabase-js';

// Replace these with your actual Supabase project credentials
// You can find these in your Supabase project settings > API
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'YOUR_SUPABASE_URL';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY';

const inProcessLock = async <TResult>(
	_name: string,
	_acquireTimeout: number,
	fn: () => Promise<TResult>,
): Promise<TResult> => fn();

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
	auth: {
		// Avoid browser lock abort errors in some environments by using an in-process lock.
		lock: inProcessLock,
	},
});
